<script>
import { Event } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
              multilingual: true
            }),
            new fields.ForeignKey({
              service: Event,
              label: 'Wydarzenia',
              modelPath: [this, 'form', 'events'],
              multiple: true,
              sortable: true,
              labelField: 'title_pl',
              required: true,
              maxItems: 3,
              help: 'Maksymalnie można umieścić 3 wydarzenia.'
            })
          ]
        }
      ]
    }
  }
}
</script>
